var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBCcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h416c26.4 0 48 21.6 48 48v288c0 26.4-21.6 48-48 48H48c-26.4 0-48-21.6-48-48V112c0-26.4 21.6-48 48-48zm124.12 96.58H82.84c-10.75 0-19.34 8.71-19.34 19.34v154.71c0 10.67 8.66 19.33 19.34 19.33h89.28c18.06 0 33.48-5.56 46.25-16.68 12.78-11.12 19.17-24.51 19.17-40.16 0-15.55-6.54-28.83-19.07-39.85 12.53-11.01 19.07-24.29 19.07-39.84 0-15.65-6.39-29.05-19.17-40.16-13.22-11.51-28.84-16.69-46.25-16.69zm6.29 118.26c8.84 0 16 7.16 16 16 0 8.83-7.17 16-16 16h-71.78v-32h71.78zm0-75.13c8.84 0 16 7.16 16 16s-7.17 16-16 16h-71.78v-32h71.78zM418.5 287.7c-41.2 37.9-92.2 15.4-92.2-32.6 0-46.1 53.8-63.2 94.6-31.2 2.9 2.3 7.2 1.4 9.1-1.7l17.5-30.5c1.5-2.5 1.1-3.7-1-5.7-50.8-49.4-172.5-27.2-172.5 70.1 0 100 119.2 124.8 172.7 67.9 2-2.1 2.2-5.3.5-7.7l-19.5-27.7c-2.1-3-6.4-3.4-9.2-.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCcard);
export default __webpack_public_path__ + "static/media/BCcard.625ffca3b7bd19db8088aea127a3f4b4.svg";
export { ForwardRef as ReactComponent };